import { Box, View, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const StyledLogo = View.withConfig({
  height: '50px',
  width: '50px',
  marginX: 'auto',
  padding: '$1.5',
});

export const StyledBox = Box.withConfig({
  padding: '$4',
  width: 'full',
  maxWidth: '600px',
  margin: 'auto',
});

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  width: 'full',
  alignSelf: 'center',
  marginTop: '$4',
});
